import React, { useEffect, useRef, useState } from "react";
import ReactMapGL, { Marker, Popup } from "react-map-gl";
import { IMarker } from "redux/utils/interfaces";
import { useSize } from "react-hook-size";
import { useMap } from "./hooks/useMap";
import Pin from "../mapPin/Pin";
import { useSelector, useDispatch } from "react-redux";
import { rootReducerType } from 'redux/combineReducers';
import "./Map.less";

const MAP_CONFIG = {
	maxZoom: 20,
	// zoom: 16,
	mapStyle: "mapbox://styles/mapbox/streets-v11",
	mapboxApiAccessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN,
	zoomEnabled: true,
};

type Props = {
	markers: IMarker[];
	stationData: any;
};

const Map = ({ markers, stationData }: Props) => {
	const mapRef = useRef(null);
	const mapContainerRef = useRef(null);
	const { width, height } = useSize(mapContainerRef);

	const { stationIndex } = useSelector(
		(state: rootReducerType) => state.stationIndexReducer
	);

	const [popupData, setPopupData] = useState<any>(null);

	useEffect(() => {
		if(stationIndex == 0) {
			onViewportChange({
				width: width as number,
				height: height as number,
				latitude: 47.653134548527,
				longitude: -122.302769517333,
				zoom: 3,
			})
			setShowPopup(false)
		}
		else if (stationData && markers.length) {
			// find index of station in markers
			let popupObj = {}
			let chosenIndex = 0
			for (let i = 0; i < markers.length ; i++) {
				if (markers[i].id === stationIndex) {
					popupObj = {
						latitude: markers[i].latitude,
						longitude: markers[i].longitude,
						locStr: markers[i].locStr,
						zoom: 16
					}
					chosenIndex = i
					break;
				}
			}
			
			setPopupData(popupObj)
			onViewportChange({
				width: width as number,
				height: height as number,
				latitude: markers[chosenIndex].latitude,
				longitude: markers[chosenIndex].longitude,
				zoom: 16,
			})
		}

		if (stationIndex > 0) {
			setShowPopup(true)
		}
	}, [stationIndex, stationData])



	// 创建一个事件监听器，用于监听容器的大小变化
	const [newWidth, setNewWidth] = useState(0)
	const [newHeight, setNewHeight] = useState(0)

	const { viewport, onViewportChange } = useMap({
		width: width || '100%',
		height: height || '100%',
		latitude: 47.653134548527,
		longitude: -122.302769517333,
		markers: [],
	});

	useEffect(() => {
		const mapContainer: any = mapContainerRef.current;
		const handleResize = () => {
			const newWidth = mapContainer.clientWidth - 5;
			const newHeight = mapContainer.clientHeight;


			setNewWidth(newWidth)
			setNewHeight(newHeight)
		};

		handleResize();
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, [])


	const viewPort = {
		width: newWidth || '100%',
		height: newHeight || '100%',
		// latitude: 37.7749, // 设置地图初始纬度
		// longitude: -122.4194, // 设置地图初始经度
		// maxZoom: 10, // 设置地图初始缩放级别
	}

	const [showPopup, setShowPopup] = useState<boolean>(true);

	return (
		<div ref={mapContainerRef} className="map">
			<ReactMapGL
				zoom={popupData ? popupData.zoom : 3}
				ref={mapRef}
				{...MAP_CONFIG}
				{...viewport}
				onViewportChange={onViewportChange}
			>
				{markers && markers.length
					? markers.map(({ id, color, ...marker }) => {
						return (
							<Marker key={id} {...marker} offsetLeft={-17.5} offsetTop={-38}>
								<Pin color={color} id={id} />
							</Marker>
						);
					})
					: null}
				{showPopup && popupData ? (
					<Popup longitude={popupData.longitude} latitude={popupData.latitude}
						anchor="top"
						onClose={() => setShowPopup(false)}>
						{popupData.locStr}
					</Popup>) : null}
			</ReactMapGL>
		</div>
	);
};

export default Map;
